export default "__VITE_ASSET__XnDnZrhC__"